import { notifications } from '@mantine/notifications';
import type { ToastProps } from './toast.model';

const defaultValues = {
  title: 'Gagal',
  message: 'Gagal Menyimpan Data',
};

export const error = (props?: ToastProps) => {
  const { id, cb, ...others } = props ?? {};
  notifications.show({
    ...defaultValues,
    ...others,
    color: 'error',
    id,
  });
  if (id) {
    notifications?.update({ ...defaultValues, ...others, id });
  }
  cb?.();
};
